// extracted by mini-css-extract-plugin
export var sliderRange = "_d4-2";
export var sliderRoot = "_d4-0";
export var sliderThumb = "_d4-3";
export var sliderTrack = "_d4-1";